module.exports = __webpack_public_path__ + "img/linktree.f91748b6.svg";